var exports = {
  "kL": "x31de4314--69a5ec--container",
  "s2": "x31de4314--69a5ec--lock",
  "Qq": "x31de4314--69a5ec--text",
};

module.exports = exports;
